var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.225 17.25C5.27813 17.25 4.125 16.0969 4.125 15.15V7.5H3.675C2.89219 7.5 2.25 8.14219 2.25 8.925V21.75L4.99219 19.0312H15.075C15.8578 19.0312 16.5 18.3703 16.5 17.5828V17.25H6.225Z",
    fill: "#8E8E93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1141 2.25H7.02656C6.12656 2.25 5.39062 2.98594 5.39062 3.88594V14.4844C5.39062 15.3844 6.12656 16.125 7.02656 16.125H18.1922L21.75 18.6094V3.88594C21.75 2.98594 21.0141 2.25 20.1141 2.25Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.2af24b421be5d43eb970d09fc30c70ee.svg";
export { ForwardRef as ReactComponent };